import { FC } from 'react';

import { Route } from 'react-router-dom';

import { RouteDataDefinition } from 'types/route';

const AppRoute: FC<RouteDataDefinition> = ({ path, ...props }) => {
    return <Route {...props} path={path}/>
};

export default AppRoute;
